import { render, staticRenderFns } from "./BAutocompleteFileType.vue?vue&type=template&id=94f990f0&"
import script from "./BAutocompleteFileType.vue?vue&type=script&lang=js&"
export * from "./BAutocompleteFileType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports